import { initSelectDropdowns } from './components/selectdropdown';
import JustValidate, { Rules } from 'just-validate';
import { addToastListener, initToasts } from './components/toast';

document.addEventListener('DOMContentLoaded', () => {
  initSelectDropdowns();
  applyFormValidation();
  initToasts();
  addToastListener();
});

function applyFormValidation() {
  const form = document.getElementById('ContactForm') as HTMLFormElement | null;

  if (!form) return;

  const validate = new JustValidate('#ContactForm', {
    errorFieldStyle: '',
    errorFieldCssClass: '!border-destructive !border-2',
    errorLabelCssClass: 'text-destructive text-sm',
    errorLabelStyle: '',
    validateBeforeSubmitting: true,
    submitFormAutomatically: false,
    focusInvalidField: true,
  });
  validate
    .addField('#ContactForm_Email', [
      {
        rule: Rules.Required,
        errorMessage: 'Email is required',
      },
      {
        rule: Rules.Email,
      },
      {
        rule: Rules.MaxLength,
        value: 255,
      },
    ])
    .addField('#ContactForm_Name', [
      {
        rule: Rules.Required,
        errorMessage: 'Name is required',
      },
      {
        rule: Rules.MaxLength,
        value: 50,
      },
    ])
    .addField('#ContactForm_Desc', [
      {
        rule: Rules.Required,
        errorMessage: 'Message is required',
      },
      {
        rule: Rules.MaxLength,
        value: 1000,
      },
    ])
    .addField(
      '#ContactForm_Inquiry',
      [
        {
          rule: Rules.Required,
          errorMessage: 'Please select an inquiry',
        },
      ],
      {
        errorsContainer: '#errors-container-inquiry',
      },
    )
    .addField('#ContactForm_Tel', [
      {
        rule: Rules.CustomRegexp,
        value: /^\D*(\d\D*){11}$/,
        errorMessage: 'Please enter a valid phone number',
      },
    ]);
}
